import React, { useState } from "react"
import "./HomePage.css"

const TOPICS = {
  regional: {
    title: "Comprehensive Regional Coverage",
    small: "Asia, MENA and Sub-Saharan Africa",
    copy: "Follow the energy, economic and industrial developments shaping Asia, the Middle East and North Africa, and Sub-Saharan Africa. Regional analysis connects global market movements with local supply, demand, trade and investment conditions. This helps users understand not only what is changing, but how the impact differs across countries and regions.",
    icon: "/assets/icon-regional.png",
  },
  updates: {
    title: "Timely + Reliable Energy Updates",
    small: "Oil, gas, LNG, coal and electricity",
    copy: "Track developments across oil, natural gas, LNG, coal and electricity markets through regularly refreshed intelligence. EnergyPulseWorld highlights important price movements, supply changes and market disruptions, while comparing recent trends with previous periods. The analysis places those energy developments in the wider context of industry, inflation and international trade.",
    icon: "/assets/icon-updates.png",
  },
  products: {
    title: "Track Energy-Sensitive Products",
    small: "Fertilizers, steel, aluminium and cement",
    copy: "Monitor energy-intensive products including urea, ammonia, steel, aluminium and cement, where energy and transport costs can materially influence market prices. EnergyPulseWorld follows price direction, import exposure and relevant supply-side developments. The objective is to show how changes in energy markets can transmit into industrial costs, competitiveness and trade flows.",
    icon: "/assets/icon-products.png",
  },
  economic: {
    title: "Country Economic Performance",
    small: "Growth, inflation, investment and trade",
    copy: "Compare country performance through key indicators such as GDP growth, consumer and producer inflation, foreign direct investment and selected trade measures. These indicators help place energy-market developments within the broader economic environment of each country. Combined analysis supports clearer assessment of market conditions, cost pressures and potential business exposure.",
    icon: "/assets/icon-economic.png",
  },
}

const HomePage = () => {
  const [active, setActive] = useState(null)

  const handleTopicClick = (key) => {
    setActive((prev) => (prev === key ? null : key))
  }

  const activeData = active ? TOPICS[active] : null

  return (
    <div className="epw-home">
      <main>
        <section
          className={`epw-simple-hero${active ? " is-expanded" : ""}`}
          aria-label="EnergyPulseWorld intelligence overview"
        >
          <div className="epw-main-column">
            <div className="epw-hero-intro">
              <h1>Energy Intelligence. Economic Insight.</h1>
            </div>

            <div className="epw-detail-panel" aria-live="polite" aria-hidden={!active}>
              {activeData && (
                <>
                  <div className="epw-detail-heading">
                    <img src={activeData.icon} alt="" />
                    <div>
                      <p className="epw-detail-kicker">EnergyPulseWorld intelligence</p>
                      <h2>{activeData.title}</h2>
                    </div>
                  </div>
                  <p className="epw-detail-copy">{activeData.copy}</p>
                  <a className="epw-detail-link" href="/login" aria-label={`Explore ${activeData.title}`}>
                    Explore more
                  </a>
                </>
              )}
            </div>

            <div className="epw-overview-copy">
              <h2>Four connected views of the energy economy</h2>
              <p>
                EnergyPulseWorld brings regional intelligence, energy-market updates,
                energy-sensitive product tracking and country economic indicators into
                one connected analytical view. Select any topic to see how each layer
                contributes to a clearer understanding of market risks and opportunities.
              </p>
            </div>
          </div>

          <div className="epw-topic-column" aria-label="Four EnergyPulseWorld intelligence areas">
            {Object.entries(TOPICS).map(([key, topic]) => (
              <button
                key={key}
                className="epw-topic"
                type="button"
                aria-expanded={active === key}
                onClick={() => handleTopicClick(key)}
              >
                <img src={topic.icon} alt="" />
                <span className="epw-topic-text">
                  <strong>{topic.title}</strong>
                  <small>{topic.small}</small>
                </span>
              </button>
            ))}

            <p className="epw-toggle-hint">Click a topic to expand. Click it again to return.</p>
          </div>
        </section>
      </main>
    </div>
  )
}

export default HomePage
